import { render, staticRenderFns } from "./TransactionsTableTypeColumnContent.vue?vue&type=template&id=9e143ae6"
import script from "./TransactionsTableTypeColumnContent.vue?vue&type=script&lang=js"
export * from "./TransactionsTableTypeColumnContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports